import { AuthService } from './auth.service';
import { RegistrationService } from './registration.service';
import { ModalService } from './modal.service';
import { AORegistrationService } from './ao-registration.service';
import { IdleService } from './idle.service';
import { UserService } from './user.service';

export const AUTH_SERVICES = [
  AuthService,
  IdleService,
  ModalService,
  UserService,
  { provide: RegistrationService, useClass: AORegistrationService },

];

export {
  AuthService,
  IdleService,
  ModalService,
  RegistrationService,
  UserService
};



// WEBPACK FOOTER //
// ./src/app/auth/services/index.ts